// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://catmongvebeektgouqjz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNhdG1vbmd2ZWJlZWt0Z291cWp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkzODM2MTcsImV4cCI6MjA1NDk1OTYxN30.y_FkktGRDMHxx5irWGEDgZmireFCXAAKBSUjSwuQ97s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);